/* OAY sale engine — one timer drives every countdown on the site.
   Settings live in the "OAY Sale" section (Header group) and arrive as JSON in #oay-config. */
(function () {
  var cfgEl = document.getElementById('oay-config');
  if (!cfgEl) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!C.enabled) return;

  var root = document.documentElement;
  root.classList.add('oay-on');

  /* "2026-10-12 20:00" is read as India time (IST, UTC+05:30) */
  function parseEnd(s) {
    if (!s) return null;
    var m = String(s).trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})[ T](\d{1,2}):(\d{2})/);
    if (!m) return null;
    return Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]) - 330 * 60000;
  }
  /* the real sale end: every countdown on the site counts down to this one moment */
  var END = parseEnd(C.end);

  function pad(n) { return n < 10 ? '0' + n : String(n); }
  /* counts down to the sale end; without an end time, falls back to the next midnight India time */
  function left() {
    var now = Date.now(), day = 86400000, off = 330 * 60000;
    var target = END !== null ? END : (Math.floor((now + off) / day) + 1) * day - off;
    var ms = Math.max(0, target - now);
    var s = Math.floor(ms / 1000);
    return { ms: ms, h: Math.floor(s / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
  }
  function money(n) { return '₹' + Math.round(n).toLocaleString('en-IN'); }
  function amounts(el) {
    if (!el) return [];
    var out = [], re = /(?:₹|Rs\.?)\s*([\d,]+(?:\.\d+)?)/g, m;
    var t = el.textContent || '';
    while ((m = re.exec(t))) out.push(parseFloat(m[1].replace(/,/g, '')));
    return out;
  }
  function fromTpl(id) {
    var t = document.getElementById(id);
    if (!t) return null;
    return t.content.firstElementChild.cloneNode(true);
  }

  /* ---------- countdowns ---------- */
  function gkRoot() {
    var host = document.querySelector('shadow-dom-container');
    return host && host.shadowRoot ? host.shadowRoot : null;
  }
  function timerNodes() {
    var list = Array.prototype.slice.call(document.querySelectorAll('[data-oay-timer]'));
    var sr = gkRoot();
    if (sr) list = list.concat(Array.prototype.slice.call(sr.querySelectorAll('[data-oay-timer]')));
    return list;
  }
  function tick() {
    var p = left();
    if (END !== null && END <= Date.now()) root.classList.add('oay-ended');
    /* more than 48 hours out: show days / hours / minutes instead of 340 hours */
    var long = p.h >= 48;
    var v, l;
    if (long) {
      v = [String(Math.floor(p.h / 24)), pad(p.h % 24), pad(p.m)];
      l = ['DAYS', 'HRS', 'MIN'];
    } else {
      v = [pad(p.h), pad(p.m), pad(p.s)];
      l = ['HRS', 'MIN', 'SEC'];
    }
    var els = timerNodes();
    for (var i = 0; i < els.length; i++) {
      var el = els[i], f = el.getAttribute('data-oay-timer');
      if (f === 'boxes') {
        var nums = [el.querySelector('[data-oay-h]'), el.querySelector('[data-oay-m]'), el.querySelector('[data-oay-s]')];
        var labs = el.querySelectorAll('small');
        for (var k = 0; k < 3; k++) {
          if (nums[k] && nums[k].textContent !== v[k]) nums[k].textContent = v[k];
          if (labs[k] && labs[k].textContent !== l[k]) labs[k].textContent = l[k];
        }
      } else if (f === 'words') {
        el.textContent = long ? v[0] + 'd ' + v[1] + 'h ' + v[2] + 'm' : v[0] + 'h ' + v[1] + 'm ' + v[2] + 's';
      } else {
        el.textContent = long ? v[0] + 'd ' + v[1] + ':' + v[2] : v[0] + ':' + v[1] + ':' + v[2];
      }
    }
  }

  /* ---------- product page: timer inside the existing price block ---------- */
  function pdp() {
    if (!C.pdp) return;
    var blocks = document.querySelectorAll('.bb-price-block');
    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i];
      if (b.querySelector('.oay-pdp')) continue;
      var node = fromTpl('oay-tpl-pdp');
      if (!node) return;
      var anchor = b.querySelector('.bb-mrp-line') || b.querySelector('.bb-drop');
      if (anchor) anchor.insertAdjacentElement('afterend', node); else b.appendChild(node);
    }
  }

  /* ---------- collection pages: timer card between products ---------- */
  function cardsOf(grid) {
    var out = [];
    for (var i = 0; i < grid.children.length; i++) {
      var c = grid.children[i];
      if (c.classList.contains('oay-gridcard')) continue;
      if (c.hidden) continue;
      if (c.matches('product-item, .product-item, .cfc, .bp-card') || c.querySelector('product-item, .cfc')) out.push(c);
    }
    return out;
  }
  function collectionGrids() {
    if (!C.grid || C.template !== 'collection') return;
    var seen = [];
    var cands = document.querySelectorAll('.product-list__inner, .cfc, .oay-cat .bulk-purchase__grid');
    for (var i = 0; i < cands.length; i++) {
      var g = cands[i].classList.contains('cfc') ? cands[i].parentElement : cands[i];
      if (g.classList.contains('cfc__link')) continue;
      if (seen.indexOf(g) > -1) continue;
      seen.push(g);
      if (g.closest('#mini-cart, .drawer, header, .scroller')) continue;
      if (getComputedStyle(g).display !== 'grid') continue;
      if (g.querySelector(':scope > .oay-gridcard')) continue;
      var cards = cardsOf(g);
      var after = Math.max(1, parseInt(C.gridAfter, 10) || 4);
      if (cards.length <= after) continue;
      var node = fromTpl('oay-tpl-grid');
      if (!node) return;
      cards[after - 1].insertAdjacentElement('afterend', node);
    }
  }

  /* ---------- sale badge on every product card ---------- */
  function badges() {
    if (!C.badges) return;
    /* .bp-card = category / pack pages (size row + Add to cart cards) */
    var cards = document.querySelectorAll('product-item, .cfc, .bp-card');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      if (c.getAttribute('data-oay-badged')) continue;
      if (c.closest('#mini-cart footer')) { c.setAttribute('data-oay-badged', '1'); continue; }
      var priceEl = c.querySelector('.cfc__price, .product-item-meta__price-list-container, .price-list, .bp-card__price-wrapper');
      var media = c.querySelector('.cfc__media, .product-item__image-wrapper, .bp-card__slider-wrapper');
      if (!priceEl || !media) continue;
      var a = amounts(priceEl).slice(0, 2);
      /* bp-card sale price is added a moment later (packCards); look again on the next pass */
      if (a.length < 2 && c.classList.contains('bp-card')) continue;
      c.setAttribute('data-oay-badged', '1');
      if (a.length < 2) continue;
      var hi = Math.max(a[0], a[1]), lo = Math.min(a[0], a[1]);
      if (!(hi > lo)) continue;
      var pct = C.halfPrices === false ? Math.round((hi - lo) / hi * 100) : 50;
      if (pct < 1) continue;
      var b = document.createElement('span');
      b.className = 'oay-badge' + (c.classList.contains('bp-card') ? ' oay-badge--bp' : '');
      b.textContent = '−' + pct + '%';
      media.appendChild(b);
    }
  }

  /* ---------- side cart: savings banner + timer ---------- */
  function cart() {
    if (!C.cart) return;
    var drawer = document.getElementById('mini-cart');
    if (!drawer) return;
    var save = 0, lines = drawer.querySelectorAll('line-item');
    for (var i = 0; i < lines.length; i++) {
      var a = amounts(lines[i].querySelector('[class*="price-list"]')).slice(0, 2);
      if (a.length === 2 && a[1] > a[0]) save += a[1] - a[0];
      else if (a.length === 2 && a[0] > a[1]) save += a[0] - a[1];
    }
    var banner = drawer.querySelector('.oay-cart');
    if (!banner) {
      banner = fromTpl('oay-tpl-cart');
      var head = drawer.querySelector('.drawer__header');
      if (!banner || !head) return;
      head.insertAdjacentElement('afterend', banner);
    }
    var amt = banner.querySelector('[data-oay-save]');
    if (amt) amt.textContent = money(save);
    banner.classList.toggle('oay-cart--nosave', !(save > 0));
    var btns = drawer.querySelectorAll('.drawer__footer button, .drawer__footer a');
    for (var j = 0; j < btns.length; j++) {
      if (/^\s*checkout/i.test(btns[j].textContent)) btns[j].classList.add('oay-grad-btn');
    }
  }

  /* ---------- GoKwik side cart (open shadow DOM): banner, timer, gradient checkout ---------- */
  var GK_CSS =
    '.oay-cart{padding:12px 16px;display:flex;align-items:center;justify-content:space-between;gap:12px;' +
    'background:var(--oay-grad-deep);color:#0A0A0A;text-shadow:none;font-family:inherit}' +
    '.oay-cart__kicker{display:block;font-size:10px;font-weight:700;letter-spacing:.18em;opacity:.9}' +
    '.oay-cart__save{display:block;font-size:16px;font-weight:800}' +
    '.oay-cart--nosave .oay-cart__save-wrap{visibility:hidden}' +
    '.oay-cart__timer{text-align:right;font-size:11px}' +
    '.oay-cart__timer b{display:block;font-size:16px;font-weight:800;font-variant-numeric:tabular-nums}' +
    '.oay-cart--ended .oay-cart__timer{display:none}' +
    '.gokwik-checkout button{background:var(--oay-grad-deep)!important;background-color:var(--oay-g2)!important;' +
    'color:#0A0A0A!important;border-color:transparent!important;text-shadow:none}' +
    '.gokwik-checkout button *{color:#0A0A0A!important;text-shadow:none!important;opacity:1!important}' +
    /* upsell "50% off" pills and the "Saved so far" ribbon: sale green instead of GoKwik teal */
    '.discount-banner{background:#29F500!important;color:#0A0A0A!important;font-weight:800!important}' +
    '.ribbon{background:#29F500!important;box-shadow:0 2px 8px rgba(41,245,0,.35)}' +
    '.ribbon::before{background:#178A00!important;border-right-color:#29F500!important}' +
    '.ribbon::after{background:#178A00!important;border-left-color:#29F500!important}' +
    '.ribbon .info,.ribbon .footer-ribbon-text{color:#0A0A0A!important;font-weight:800!important}';
  var gkObserved = null;
  function gkCart() {
    if (!C.cart) return;
    var sr = gkRoot();
    if (!sr) return;
    if (gkObserved !== sr) {
      gkObserved = sr;
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          var n = list[i].target;
          if (n && n.nodeType === 3) n = n.parentElement;
          if (n && n.closest && (n.closest('[data-oay-timer]') || n.closest('.oay-cart'))) continue;
          schedule();
          return;
        }
      }).observe(sr, { childList: true, subtree: true, characterData: true });
    }
    if (!sr.getElementById('oay-gk-style')) {
      var st = document.createElement('style');
      st.id = 'oay-gk-style';
      st.textContent = GK_CSS;
      sr.appendChild(st);
    }
    var head = sr.querySelector('.side-cart-header');
    if (!head) return;
    var banner = sr.querySelector('.oay-cart');
    if (!banner) {
      banner = fromTpl('oay-tpl-cart');
      if (!banner) return;
      head.insertAdjacentElement('afterend', banner);
    }
    var a = amounts(sr.querySelector('.total-amount')).slice(0, 2);
    var save = a.length === 2 ? Math.abs(a[0] - a[1]) : 0;
    var amt = banner.querySelector('[data-oay-save]');
    var txt = money(save);
    if (amt && amt.textContent !== txt) amt.textContent = txt;
    banner.classList.toggle('oay-cart--nosave', !(save > 0));
    banner.classList.toggle('oay-cart--ended', root.classList.contains('oay-ended'));
  }

  /* ---------- header: running gradient on the logo ---------- */
  /* The gradient is cut out with the logo file itself as a mask, so it works on
     white and on see-through headers alike. The real <img> stays for layout and SEO. */
  function logo() {
    if (!C.logo) return;
    var links = document.querySelectorAll('.header__logo-link');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var img = link.querySelector('img.header__logo-image:not(.header__logo-image--transparent)') || link.querySelector('img');
      if (!img) continue;
      var fx = link.querySelector('.oay-logo__fx');
      if (!fx) {
        fx = document.createElement('span');
        fx.className = 'oay-logo__fx';
        fx.setAttribute('aria-hidden', 'true');
        link.appendChild(fx);
        link.classList.add('oay-logo-link');
      }
      var src = img.currentSrc || img.src;
      if (src && fx.getAttribute('data-src') !== src) {
        fx.setAttribute('data-src', src);
        fx.style.setProperty('--oay-logo-url', 'url("' + src + '")');
      }
      var lr = link.getBoundingClientRect(), ir = img.getBoundingClientRect();
      if (ir.width > 0) {
        fx.style.left = Math.round(ir.left - lr.left) + 'px';
        fx.style.top = Math.round(ir.top - lr.top) + 'px';
        fx.style.width = Math.round(ir.width) + 'px';
        fx.style.height = Math.round(ir.height) + 'px';
      }
    }
  }

  /* ---------- fixed bar: tell the header how tall the bar is ---------- */
  var lastBarH = -1;
  function barHeight() {
    var sec = document.querySelector('.oay-sale-section');
    if (!sec) return;
    var h = Math.round(sec.getBoundingClientRect().height);
    if (h !== lastBarH) {
      lastBarH = h;
      root.style.setProperty('--oay-bar-h', h + 'px');
    }
    var hdr = document.querySelector('.shopify-section--header');
    var hh = hdr ? Math.round(hdr.getBoundingClientRect().height) : 0;
    root.style.setProperty('--oay-stack-h', (h + hh) + 'px');
  }

  /* ---------- Bundle & Save rows: price = 50% of the struck MRP ---------- */
  function bundles() {
    if (!C.bundleHalf) return;
    var rows = document.querySelectorAll('.bundle-showcase__row');
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      if (r.getAttribute('data-oay-half')) continue;
      var mrpEl = r.querySelector('.bundle-showcase__mrp');
      var priceEl = r.querySelector('.bundle-showcase__price');
      var mrp = amounts(mrpEl)[0];
      r.setAttribute('data-oay-half', '1');
      if (!mrp || !priceEl) continue;
      priceEl.setAttribute('data-oay-was', priceEl.textContent.trim());
      priceEl.textContent = money(mrp / 2);
      priceEl.classList.add('oay-bprice');
      var save = r.querySelector('.bundle-showcase__save');
      if (!save) {
        save = document.createElement('div');
        save.className = 'bundle-showcase__save';
        r.querySelector('.bundle-showcase__pricing').appendChild(save);
      }
      save.textContent = C.bundleBadge || '50% OFF';
      save.classList.add('oay-bsave');
    }
  }

  /* Pack page cards: struck MRP -> 50% price, and a simpler bottom bar message */
  var PACK_MSG = 'Keep adding more \u2014 it\u2019s once a year.';
  function packCards(sec) {
    var cards = sec.querySelectorAll('.bp-card');
    for (var i = 0; i < cards.length; i++) {
      var pr = cards[i].querySelector('.bp-card__price');
      if (!pr || pr.parentElement.querySelector('.oay-bp-now')) continue;
      var mrp = amounts(pr)[0];
      if (!mrp) continue;
      var arrow = document.createElement('span');
      arrow.className = 'oay-bp-arrow';
      arrow.textContent = '\u2192';
      var now = document.createElement('span');
      now.className = 'oay-bp-now';
      now.textContent = money(mrp / 2);
      packDone.add(now.firstChild);
      pr.insertAdjacentElement('afterend', arrow);
      arrow.insertAdjacentElement('afterend', now);
    }
    var banners = sec.querySelectorAll('.bundle-preview__tier-banner');
    for (var j = 0; j < banners.length; j++) {
      if (banners[j].querySelector('.oay-tier-msg')) continue;
      var msg = document.createElement('div');
      msg.className = 'oay-tier-msg';
      msg.textContent = PACK_MSG;
      banners[j].appendChild(msg);
    }
  }

  /* ---------- Pack pages (bulk purchase): each = 50% of MRP ---------- */
  var packDone = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  function packs() {
    if (!C.bundleHalf || !packDone) return;
    var secs = document.querySelectorAll('section.bulk-purchase');
    for (var i = 0; i < secs.length; i++) {
      var sec = secs[i];
      var map = sec._oayMap;
      if (!map) {
        var mrp = amounts(sec.querySelector('.bp-hero__mrp'))[0];
        var nowEl = sec.querySelector('.bp-hero__now');
        var eachOld = amounts(nowEl)[0];
        var totalEl = sec.querySelector('.bp-hero__total');
        var totalOld = amounts(totalEl)[0];
        var saveOld = amounts(sec.querySelector('.bp-hero__save'))[0];
        var nm = totalEl && totalEl.textContent.match(/for\s+(\d+)/i);
        var n = nm ? parseInt(nm[1], 10) : 2;
        if (!mrp || !eachOld) continue;
        var eachNew = Math.round(mrp / 2);
        var totalNew = eachNew * n;
        var saveNew = Math.round(mrp * n - totalNew);
        map = {};
        map[eachOld] = eachNew;
        if (totalOld) map[totalOld] = totalNew;
        if (saveOld) map[saveOld] = saveNew;
        sec._oayMap = map;
        var saveEl = sec.querySelector('.bp-hero__save');
        if (saveEl) { saveEl.textContent = C.bundleBadge || '50% OFF'; packDone.add(saveEl.firstChild); }
        /* mixed prices in one pack (Air Cargo: ₹1,890 regular, ₹1,990 straight fit): a single
           "₹945 each · ₹1,890 for 2" would be wrong for half the picks, so lead with "from" */
        var halves = [];
        var cps = sec.querySelectorAll('.bp-card__price');
        for (var q = 0; q < cps.length; q++) {
          var cm = amounts(cps[q])[0];
          if (cm) { var hv = Math.round(cm / 2); if (halves.indexOf(hv) < 0) halves.push(hv); }
        }
        if (halves.length > 1) {
          var lo = Math.min.apply(null, halves);
          if (nowEl && nowEl.firstChild && nowEl.firstChild.nodeType === 3) {
            nowEl.firstChild.nodeValue = 'from ' + money(lo);
            packDone.add(nowEl.firstChild);
          }
          if (totalEl) {
            totalEl.textContent = 'from ' + money(lo * n) + ' for ' + n + ' \u00b7 every piece at 50% of its MRP';
            packDone.add(totalEl.firstChild);
          }
        }
      }
      packCards(sec);
      var walker = document.createTreeWalker(sec, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        if (packDone.has(node)) continue;
        packDone.add(node);
        var t = node.nodeValue;
        if (!/₹|Rs\.?/.test(t)) continue;
        var nt = t.replace(/(₹|Rs\.?)\s*([\d,]+)(?:\.\d+)?/g, function (all, sym, num) {
          var v = parseFloat(num.replace(/,/g, ''));
          return map.hasOwnProperty(v) ? money(map[v]) : all;
        });
        if (nt !== t) node.nodeValue = nt;
      }
    }
  }

  /* ---------- Shop by Looks: every look shows at 50% of its MRP ---------- */
  function looks() {
    if (!C.bundleHalf) return;
    var i, c;
    /* look cards in the "Wear it as a whole look" rail on product pages */
    var rail = document.querySelectorAll('[id*="shop_by_looks"] .bb-a2, [id*="shop-by-looks"] .bb-a2');
    for (i = 0; i < rail.length; i++) {
      c = rail[i];
      if (c.getAttribute('data-oay-look')) continue;
      c.setAttribute('data-oay-look', '1');
      var m = amounts(c.querySelector('.bb-a2__mrp'))[0];
      if (!m) continue;
      var nw = c.querySelector('.bb-a2__now'), sv = c.querySelector('.bb-a2__save');
      if (nw) nw.textContent = money(Math.round(m / 2));
      if (sv) sv.textContent = 'SAVE 50%';
    }
    /* the look's own product page */
    var buys = document.querySelectorAll('.look-buy');
    for (i = 0; i < buys.length; i++) {
      var lb = buys[i];
      if (lb.getAttribute('data-oay-look')) continue;
      var mrp = amounts(lb.querySelector('.mrp'))[0];
      if (!mrp) continue;
      lb.setAttribute('data-oay-look', '1');
      var half = Math.round(mrp / 2);
      var pr = lb.querySelector('.price-row .price');
      if (pr) pr.textContent = money(half);
      var save = lb.querySelector('.price-row .save');
      if (!save && pr) { save = document.createElement('div'); save.className = 'save'; pr.insertAdjacentElement('afterend', save); }
      if (save) save.textContent = 'SAVE 50%';
      var vs = lb.querySelector('.vs-note');
      if (vs) vs.style.display = 'none';
      var emi = lb.querySelector('.emi b');
      if (emi) emi.textContent = money(Math.round(half / 3));
      var scope = lb.closest('[id^="look-"]') || document;
      var sticky = scope.querySelectorAll('.sticky-price');
      for (var k = 0; k < sticky.length; k++) {
        sticky[k].innerHTML = '';
        sticky[k].appendChild(document.createTextNode(money(half) + ' '));
        var st = document.createElement('s'); st.textContent = money(mrp); sticky[k].appendChild(st);
      }
    }
    /* "complete another look" cards under a look page (they also feed the quick-buy drawer) */
    var sugs = document.querySelectorAll('.sug-card[data-look-compare]');
    for (i = 0; i < sugs.length; i++) {
      c = sugs[i];
      if (c.getAttribute('data-oay-look')) continue;
      c.setAttribute('data-oay-look', '1');
      var cmp = (parseInt(c.getAttribute('data-look-compare'), 10) || 0) / 100;
      if (!(cmp > 0)) continue;
      var h = Math.round(cmp / 2);
      c.setAttribute('data-look-price', String(h * 100));
      c.setAttribute('data-price-fmt', money(h));
      c.setAttribute('data-save', '50');
      c.setAttribute('data-parts-saving', '');
      var sp = c.querySelector('.sug-price');
      if (sp) {
        sp.innerHTML = '';
        sp.appendChild(document.createTextNode(money(h) + ' '));
        var s2 = document.createElement('s'); s2.textContent = money(cmp); sp.appendChild(s2);
        sp.appendChild(document.createTextNode(' '));
        var em = document.createElement('em'); em.textContent = '50% OFF'; sp.appendChild(em);
      }
    }
  }


  /* ---------- every product price = 50% of MRP, whole rupees (display only) ----------
     MRP = compare-at price, or the price itself when there is no compare-at.
     The theme rewrites some of these on variant change; the observer puts them back. */
  function orig(el) {
    var t = el.textContent.trim();
    if (el._oayW === t) return el._oayO;
    el._oayO = amounts(el)[0] || 0;
    return el._oayO;
  }
  function put(el, txt) {
    if (el.textContent.trim() !== txt) el.textContent = txt;
    el._oayW = txt;
  }
  function show(el) { if (el.style.display === 'none') el.style.display = ''; el.hidden = false; }
  var PAIRS = [
    ['.bb-drop', '.bb-drop-from', 'bb-drop-from', '.bb-drop-now', '.bb-drop-save'],
    ['.bb-a2', '.bb-a2__mrp', 'bb-a2__mrp', '.bb-a2__now', '.bb-a2__save'],
    ['.bb-sticky-price-row', '[data-bb-sticky-mrp]', '', '[data-bb-sticky-price]', '']
  ];
  var prodCache = {};
  function prodMrp(handle, cb) {
    var c = prodCache[handle];
    if (c && c.mrp) return cb(c.mrp);
    if (c) { c.q.push(cb); return; }
    c = prodCache[handle] = { mrp: 0, q: [cb] };
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
      if (!v) return;
      c.mrp = Math.max(v.compare_at_price || 0, v.price || 0) / 100;
      var q = c.q; c.q = [];
      for (var i = 0; i < q.length; i++) q[i](c.mrp);
    }).catch(function () {});
  }
  function handleOf(a) {
    var m = (a && a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }
  function halfPrices() {
    if (C.halfPrices === false) return;
    var i, j, box, mrpEl, nowEl, saveEl, mrp;
    for (i = 0; i < PAIRS.length; i++) {
      var P = PAIRS[i], boxes = document.querySelectorAll(P[0]);
      for (j = 0; j < boxes.length; j++) {
        box = boxes[j];
        nowEl = box.querySelector(P[3]);
        if (!nowEl) continue;
        mrpEl = box.querySelector(P[1]);
        mrp = Math.max(mrpEl ? orig(mrpEl) : 0, orig(nowEl));
        if (!mrp) continue;
        if (!mrpEl && P[2]) {
          mrpEl = document.createElement('span');
          mrpEl.className = P[2];
          if (P[0] === '.bb-a2') nowEl.insertAdjacentElement('afterend', mrpEl);
          else nowEl.insertAdjacentElement('beforebegin', mrpEl);
        }
        put(nowEl, money(Math.round(mrp / 2)));
        if (mrpEl) { put(mrpEl, money(mrp)); mrpEl._oayO = mrp; show(mrpEl); }
        saveEl = P[4] && box.querySelector(P[4]);
        if (saveEl) { put(saveEl, 'SAVE 50%'); show(saveEl); }
      }
    }
    /* Shop by Looks collection cards: "Rs. 3,790 <s>Rs. 5,380</s> <em>29% OFF</em>" */
    var lps = document.querySelectorAll('.look-price');
    for (i = 0; i < lps.length; i++) {
      var lp = lps[i];
      if (lp._oayH && lp._oayH === lp.innerHTML) continue;
      var lm = amounts(lp.querySelector('s'))[0] || amounts(lp)[0];
      if (!lm) continue;
      lp.innerHTML = '';
      var ln = document.createElement('span'); ln.className = 'oay-lp-now'; ln.textContent = money(Math.round(lm / 2));
      lp.appendChild(ln); lp.appendChild(document.createTextNode(' '));
      var ls = document.createElement('s'); ls.textContent = money(lm); lp.appendChild(ls);
      lp.appendChild(document.createTextNode(' '));
      var le = document.createElement('em'); le.textContent = '50% OFF'; lp.appendChild(le);
      lp._oayH = lp.innerHTML;
    }
    /* "Also available in your size" rail: "Rs. 1,590<s>Rs. 1,890</s>" */
    var rps = document.querySelectorAll('.bb-rail__price');
    for (i = 0; i < rps.length; i++) {
      var rp = rps[i];
      if (rp._oayH && rp._oayH === rp.innerHTML) continue;
      var rm = Math.max(amounts(rp.querySelector('s'))[0] || 0, amounts(rp)[0] || 0);
      if (!rm) continue;
      rp.innerHTML = '';
      rp.appendChild(document.createTextNode(money(Math.round(rm / 2)) + ' '));
      var rs = document.createElement('s'); rs.textContent = money(rm); rp.appendChild(rs);
      rp._oayH = rp.innerHTML;
    }
    /* -50% badge on the product-page photo */
    var gal = document.querySelectorAll('.product__media-list-wrapper');
    for (i = 0; i < gal.length; i++) {
      if (gal[i].querySelector(':scope > .oay-badge')) continue;
      var gb = document.createElement('span');
      gb.className = 'oay-badge oay-badge--pdp';
      gb.textContent = '−50%';
      gal[i].appendChild(gb);
    }
    /* EMI line under the product-page price */
    var blocks = document.querySelectorAll('.bb-price-block');
    for (i = 0; i < blocks.length; i++) {
      var hn = amounts(blocks[i].querySelector('.bb-drop-now'))[0];
      var emi = blocks[i].querySelector('[data-bb-emi-amount]');
      if (hn && emi) put(emi, money(Math.round(hn / 3)));
    }
    /* "Better together" cards and their quick-view sheet */
    var bts = document.querySelectorAll('[data-bt-root]');
    for (i = 0; i < bts.length; i++) {
      var root2 = bts[i];
      var thisP = root2.querySelector('.bt-card--this .bt-price');
      var pdpNow = document.querySelector('.bb-price-block .bb-drop-now');
      if (thisP && pdpNow) put(thisP.querySelector('b') || thisP, pdpNow.textContent.trim());
      var comps = root2.querySelectorAll('.bt-card--companion');
      for (j = 0; j < comps.length; j++) (function (card) {
        var h = handleOf(card);
        if (!h) return;
        prodMrp(h, function (m) {
          var el = card.querySelector('.bt-price');
          if (!el) return;
          put(el.querySelector('b') || el, money(Math.round(m / 2)));
          var st = el.querySelector('s');
          if (st) put(st, money(m));
        });
      })(comps[j]);
      var cj = root2.querySelector('[data-bt-qv-json]');
      var qh = '';
      try { qh = JSON.parse(cj.textContent).companion; } catch (e) {}
      var qp = document.querySelector('#bt-qv .bt-qv-price');
      if (qh && qp) (function (el) {
        prodMrp(qh, function (m) {
          if (el._oayH && el._oayH === el.innerHTML) return;
          el.innerHTML = '';
          el.appendChild(document.createTextNode(money(Math.round(m / 2)) + ' '));
          var s3 = document.createElement('s'); s3.textContent = money(m); el.appendChild(s3);
          var sp3 = document.createElement('span'); sp3.textContent = '50% OFF'; el.appendChild(sp3);
          el._oayH = el.innerHTML;
        });
      })(qp);
    }
  }

  /* ---------- header stays solid white while the sale runs (no see-through header over the home video) ---------- */
  function solidHeader() {
    var hs = document.querySelectorAll('store-header');
    for (var i = 0; i < hs.length; i++) {
      if (hs[i].hasAttribute('transparent')) hs[i].removeAttribute('transparent');
      if (hs[i].classList.contains('header--transparent')) hs[i].classList.remove('header--transparent');
    }
  }

  /* ---------- 999 Store rail on product pages: not relevant during the sale ---------- */
  function hide999() {
    var secs = document.querySelectorAll('[id$="__bb_999_store"], .bb-rail-section');
    for (var i = 0; i < secs.length; i++) {
      var s = secs[i];
      if (s.getAttribute('data-oay-999')) continue;
      var eb = s.querySelector('.bb-rail__eyebrow, h2, h3');
      if (/__bb_999_store$/.test(s.id) || (eb && /999/.test(eb.textContent))) {
        s.setAttribute('data-oay-999', '1');
        s.style.display = 'none';
      }
    }
  }

  /* ---------- quick view (pack + category pages): show the real formatted description ---------- */
  var qvToken = 0;
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var b = e.target.closest('[data-quick-view]');
    if (!b) {
      var img = e.target.closest('.bp-card__image');
      var card = img && img.closest('.bp-card');
      b = card && card.querySelector('[data-quick-view]');
    }
    if (!b) return;
    var url = (b.getAttribute('data-product-url') || '').split('?')[0];
    if (!url) return;
    var sec = b.closest('section.bulk-purchase') || document;
    var tok = ++qvToken;
    fetch(url + '.js').then(function (r) { return r.json(); }).then(function (p) {
      if (tok !== qvToken || !p || !p.description) return;
      var panel = sec.querySelector('[data-qv-panel="details"]');
      if (!panel) return;
      var d = document.createElement('div');
      d.className = 'oay-qv-desc';
      d.innerHTML = String(p.description).replace(/\s*\n\s*/g, ' ');
      panel.innerHTML = '';
      panel.appendChild(d);
    }).catch(function () {});
  }, true);

  /* ---------- light green tint on every plain white section (dark or coloured sections keep their colour) ---------- */
  function tint() {
    var w = document.querySelectorAll('.section__color-wrapper:not([data-oay-tint]), .shopify-section > .section:not([data-oay-tint])');
    for (var i = 0; i < w.length; i++) {
      w[i].setAttribute('data-oay-tint', '1');
      var bg = getComputedStyle(w[i]).backgroundColor;
      if (bg === 'rgb(255, 255, 255)') w[i].style.backgroundColor = 'var(--oay-tint)';
    }
  }

  function run() {
    
    try { solidHeader(); } catch (e) {}
    try { hide999(); } catch (e) {}
    try { halfPrices(); } catch (e) {}
    try { looks(); } catch (e) {}
    try { packs(); } catch (e) {}
    try { logo(); } catch (e) {}
    try { barHeight(); } catch (e) {}
    try { bundles(); } catch (e) {}
    try { pdp(); } catch (e) {}
    try { collectionGrids(); } catch (e) {}
    try { badges(); } catch (e) {}
    try { cart(); } catch (e) {}
    try { gkCart(); } catch (e) {}
    tick();
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; run(); }, 120);
  }

  function start() {
    run();
    setInterval(tick, 1000);
    window.addEventListener('resize', function () { try { barHeight(); logo(); } catch (e) {} });
    window.addEventListener('load', function () { try { logo(); } catch (e) {} });
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var n = list[i].target;
        if (n && n.nodeType === 3) n = n.parentElement;
        if (n && n.closest && n.closest('[data-oay-timer]')) continue;
        schedule();
        return;
      }
    }).observe(document.body, { childList: true, subtree: true });
    var sh = document.querySelector('store-header');
    if (sh) new MutationObserver(function () { try { solidHeader(); } catch (e) {} }).observe(sh, { attributes: true, attributeFilter: ['class', 'transparent'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
